var _excluded = ["cardWrapper", "children", "globalColumnSettings", "emptyState", "filters", "id", "isEmpty", "isLoading", "items", "labelledBy", "loadingState", "pagination", "search", "selectAllCheckbox", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import * as IconSet from "../../../icons/index.js";
import Card from "../../basic/Card/Card.js";
import Checkbox from "../../form/Checkbox/Checkbox.js";
import Input from "../../form/Input/Input.js";
import Pagination from "../Pagination/Pagination.js";
import TableHeaderOrderableButton from "./Components/TableHeaderOrderableButton.js";
import TableHeaderTooltip from "./Components/TableHeaderTooltip.js";
import TableItem from "./Components/TableItem.js";
import Number from "./Components/TableItemNumber.js";
import { ActionColumn, ColumnHeaderBadge, ColumnHeaderText, DataColumn, DataColumnContainer, InnerTableContainer, NameColumn, OuterTableContainer, TableControls, TableElement, TableEmptyState, TableHeader, TableHeaderInner, TableItemCheckbox, TableItemContainer, TableLoadingState, TablePagination, TableSearch } from "./styledComponents.js";
var isTableItemElement = element => {
  return typeof element === 'object' && /*#__PURE__*/React.isValidElement(element);
};

/* Main table component */

var Table = _ref => {
  var {
      cardWrapper = true,
      children,
      globalColumnSettings,
      emptyState = {
        heading: "There's nothing here"
      },
      filters,
      id,
      isEmpty = false,
      isLoading = false,
      items,
      labelledBy,
      loadingState = /*#__PURE__*/React.createElement("div", null, "Loading content"),
      pagination,
      search,
      selectAllCheckbox,
      size = 'medium'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var {
    action: actionColumnSettings,
    dataColumns: dataColumnSettings,
    name: nameColumnSettings
  } = globalColumnSettings;
  var showControls = search || filters;
  var showPagination = !isEmpty && pagination;
  var {
    heading: nameColumnHeading,
    headingBadge: nameColumnBadge,
    headingTooltip: nameColumnHeadingTooltip,
    minWidth: nameColumnMinWidth,
    orderable: nameColumnOrderable
  } = nameColumnSettings;
  var {
    align: actionColumnAlign,
    heading: actionColumnHeading,
    headingBadge: actionColumnBadge,
    headingTooltip: actionColumnHeadingTooltip,
    minWidth: actionColumnMinWidth
  } = actionColumnSettings || {};

  // Component proper
  return /*#__PURE__*/React.createElement(OuterTableContainer, _extends({
    as: cardWrapper ? Card : 'div',
    cardWrapper: cardWrapper,
    id: id,
    size: size
  }, props), showControls && /*#__PURE__*/React.createElement(TableControls, {
    align: search ? 'justify' : 'right',
    isLoading: isLoading,
    size: size,
    valign: "bottom"
  }, search && /*#__PURE__*/React.createElement(TableSearch, null, /*#__PURE__*/React.createElement(Input, _extends({
    fieldSize: size,
    icon: IconSet.Search
  }, search))), filters && /*#__PURE__*/React.createElement("div", null, filters)), isLoading && /*#__PURE__*/React.createElement(TableLoadingState, {
    size: size
  }, loadingState), isEmpty && !isLoading && /*#__PURE__*/React.createElement(TableEmptyState, _extends({
    size: size
  }, emptyState)), !isEmpty && /*#__PURE__*/React.createElement(InnerTableContainer, _extends({
    isLoading: isLoading,
    size: size
  }, props), /*#__PURE__*/React.createElement(TableElement, {
    "aria-labelledby": labelledBy
  }, /*#__PURE__*/React.createElement(TableHeader, {
    size: size
  }, /*#__PURE__*/React.createElement(TableHeaderInner, null, nameColumnSettings && /*#__PURE__*/React.createElement(NameColumn, {
    as: "th",
    minWidth: nameColumnMinWidth || undefined,
    size: size
  }, selectAllCheckbox && /*#__PURE__*/React.createElement(TableItemCheckbox, {
    inHeader: true,
    size: size
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({
    fieldSize: size === 'small' ? 'small' : 'medium'
  }, selectAllCheckbox))), /*#__PURE__*/React.createElement(ColumnHeaderText, null, nameColumnOrderable ? /*#__PURE__*/React.createElement(TableHeaderOrderableButton, _extends({
    heading: nameColumnHeading || 'Name'
  }, nameColumnOrderable)) : nameColumnHeading || 'Name', nameColumnHeadingTooltip && /*#__PURE__*/React.createElement(TableHeaderTooltip, {
    id: "heading-name-tip",
    text: nameColumnHeadingTooltip
  }), nameColumnBadge && /*#__PURE__*/React.createElement(ColumnHeaderBadge, nameColumnBadge))), /*#__PURE__*/React.createElement(DataColumnContainer, {
    as: "th",
    size: size
  }, dataColumnSettings && /*#__PURE__*/React.createElement("div", null, dataColumnSettings.map((currentColumnSetting, i) => {
    var {
      align,
      heading,
      headingBadge,
      headingTooltip,
      headingTooltipId,
      minWidth,
      orderable
    } = currentColumnSetting;
    return heading && /*#__PURE__*/React.createElement(DataColumn, {
      align: align,
      key: "data-column-header-".concat(i + 1),
      minWidth: minWidth,
      size: size
    }, /*#__PURE__*/React.createElement(ColumnHeaderText, {
      align: align
    }, orderable ? /*#__PURE__*/React.createElement(TableHeaderOrderableButton, _extends({
      heading: heading
    }, orderable)) : heading, headingTooltip && /*#__PURE__*/React.createElement(TableHeaderTooltip, {
      id: headingTooltipId || "heading-data-column-".concat(i + 1, "-tip"),
      text: headingTooltip
    }), headingBadge && /*#__PURE__*/React.createElement(ColumnHeaderBadge, _extends({}, headingBadge, {
      size: "small"
    }))));
  }))), actionColumnSettings && /*#__PURE__*/React.createElement(ActionColumn, {
    align: actionColumnAlign || 'right',
    as: "th",
    minWidth: actionColumnMinWidth || undefined,
    size: size
  }, /*#__PURE__*/React.createElement(ColumnHeaderText, {
    align: actionColumnAlign || 'right'
  }, actionColumnHeading || 'Actions', actionColumnHeadingTooltip && /*#__PURE__*/React.createElement(TableHeaderTooltip, {
    id: "heading-action-tip",
    text: actionColumnHeadingTooltip
  }), actionColumnBadge && /*#__PURE__*/React.createElement(ColumnHeaderBadge, actionColumnBadge))))), /*#__PURE__*/React.createElement(TableItemContainer, null, items ? items.map((itemProps, i) => {
    var itemNum = i + 1;
    var itemId = itemProps.id || "".concat(id, "-item-").concat(itemNum);

    // build an array of subItems and capture their IDs
    var {
      subItems
    } = itemProps;
    var subItemIds = [];
    var subItemElements = [];
    if (subItems) {
      subItems.forEach((subItemProps, j) => {
        var subItemNum = j + 1;
        var subItemId = subItemProps.id || "".concat(id, "-item-").concat(itemNum, "-").concat(subItemNum);
        subItemIds.push(subItemId);
        subItemElements.push(/*#__PURE__*/React.createElement(Table.Item, _extends({}, subItemProps, {
          // leave subItemProps at top
          // override original subItemProps
          globalColumnSettings: globalColumnSettings,
          key: "".concat(id, "-item-").concat(itemNum, "-").concat(subItemNum),
          id: subItemId,
          parentItem: itemId,
          size: size
        })));
      });
    }

    // build the main table item
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "".concat(id, "-item-").concat(itemNum)
    }, /*#__PURE__*/React.createElement(Table.Item, _extends({}, itemProps, {
      // leave itemProps at top
      // override original itemProps
      globalColumnSettings: globalColumnSettings,
      id: itemId,
      size: size,
      subItemIds: subItemIds.join(' ')
    })), subItemElements);
  }) : React.Children.map(children, (tableItem, i) => {
    var itemNum = i + 1;
    if (!isTableItemElement(tableItem)) return;
    return /*#__PURE__*/React.cloneElement(tableItem, {
      globalColumnSettings,
      key: "".concat(id, "-item-").concat(itemNum),
      id: "".concat(id, "-item-").concat(itemNum),
      size
    });
  })))), showPagination && pagination !== null && pagination !== void 0 && pagination.totalPages && (pagination === null || pagination === void 0 ? void 0 : pagination.totalPages) > 1 ? /*#__PURE__*/React.createElement(TablePagination, {
    isLoading: isLoading,
    size: size
  }, /*#__PURE__*/React.createElement(Pagination, _extends({
    size: size
  }, pagination))) : null);
};
Table.Item = TableItem;
Table.ItemNumber = Number;
export default Table;